import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./promiseBook.scss";
import { Radio, Button, message } from "antd";
import dataList from "./data.json";

export default function PromiseBook() {
  const history = useHistory();
  const [isCheck, setIsCheck] = useState(false);
  const [activeNum, setActiveNum] = useState(0);
  // console.info(history.location.state);

  const okBtn = (n) => {
    history.push({
      pathname: `/entrance/skillsTrainingApply/${n}`,
      // query: activeNum,
    });
    // if (isCheck) {
    //   history.push({
    //     pathname: "/entrance/skillsTrainingApply",
    //     // query: activeNum,
    //     query: n,
    //   });
    // } else {
    //   message.info("请先阅读承诺书！并勾选同意按钮");
    // }
  };
  const toDetail = (obj) => {
    history.push({
      pathname: `/entrance/promiseBookDetail`,
      state: {detail:obj},
    });
  };
  return (
    <div>
      <div className="trainingAbout">
        <div className="backBtn" onClick={() => history.goBack()}>
          返回
        </div>
        <div className="tit">眉山市退役军人教育培训联盟</div>
        <div className="con">
          为贯彻落实《国务院关于印发国家职业教育改革实施方案的通知》(国发〔2019〕4号)、《关于促进新时代退役军人就业创业工作的意见》(退役军人部发〔2018〕26号)、《关于促进新时代退役军人就业创业工作的实施意见》(川退役军人发〔2018〕10号)等文件精神，在眉山市委、市政府和市退役军人事务局、市民政局等部门的指导下，由眉山工程技师学院和相关机构、单位联合自愿发起并结成——“眉山市退役军人教育培训联盟”。联盟按照互信互惠、优势互补、共赢发展的原则，整合各方资源要素，优化资源配置，系统发挥各方人才教育培训优势，推动退役军人教育、培训、就业有机衔接，提升眉山市退役军人教育培训工作水平。
        </div>
      </div>
      <div className="telInfo">
        <div className="telInfoTit">
          符合条件的退役军人请向当地县级退役军人事务部门咨询
        </div>
        <div className="teltit">联系电话：</div>
        <div className="telInfoCon">
          <span>眉山天府新区：028-36333111转369</span>
          <span>东坡区：028-38229373</span>
          <span>彭山区：028-37666770</span>
          <span>仁寿县：028-36279887</span>
          <span>洪雅县：028-37409550</span>
          <span>丹棱县：028-37206385</span>
          <span>青神县：028-38860196</span>
        </div>
      </div>
      <div className="lmList">
        {dataList.map((item, index) => {
            return (
              <div className="lmItem" onClick={() => toDetail(item)}>
                <div className="name">{item.name}</div>
                <div className="intro">{item.about}</div>
              </div>
            )
          }
        )}
      </div>
      {/* <div className="trainingType">
        <div
          className="btn"
          onClick={() => okBtn(0)}
        >
          本地技能培训申请
        </div>
        <div className="btn yd" onClick={() => okBtn(1)}>
          异地技能培训申请
        </div>
      </div> */}
      {/* <div className="promise_book">
        <section>
          <div className="promise_book_title">
            {activeNum === 1 ? "异地" : "本地"}技能培训申请承诺书
          </div>
        </section>
        <section className="promise_book_content">
          <div className="promise_book_content_text">
            本人郑重承诺，对以下填写的内容的真实性和完整性负责，如有弄虚作假，补贴资金将退回，一切后果本人承担。
          </div>
          <p className="promise_book_content_training">
            本人为2011年11月以后退伍的自主就业退役士兵，且从未接受过免费的职业技能培训。
          </p>
          <div>
            <Radio
              checked={isCheck}
              onClick={() => setIsCheck(!isCheck)}
              className="promise_book_agree"
            >
              本人同意并遵守以上内容
            </Radio>
          </div>
          <div className="promise_book_footer">
            <Button
              className="promise_book_close_btn"
              onClick={() => history.goBack()}
            >
              关闭
            </Button>
            <Button
              type="primary"
              className="promise_book_ok_btn"
              onClick={() => {
                okBtn();
              }}
            >
              确定
            </Button>
          </div>
        </section>
      </div> */}
    </div>
  );
}
